import { useEffect, useState } from 'react';
import { AssignTaskModal } from 'setup-guide-components/components/modal/AssignTaskModal';
import { useTracker } from '../../../../hooks/tracking';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssignTaskLink = ({
  task,
  children,
  onClose,
  assignedTaskId
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    trackSectionView,
    trackUserInteraction
  } = useTracker();
  useEffect(() => {
    trackSectionView('assign task link view', task.key);
  }, [trackSectionView, task.key]);
  const openModal = () => {
    setIsOpen(true);
    trackUserInteraction('click assign task', task.key);
  };
  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: openModal,
      size: "sm",
      truncate: true,
      use: "tertiary-light",
      children: children
    }), isOpen && /*#__PURE__*/_jsx(AssignTaskModal, {
      assignmentId: assignedTaskId,
      onClose: handleClose,
      task: task
    })]
  });
};